import axios from "../../config/axios";
import { useToast } from 'vue-toastification';

const toast = {
  success(msg, options = {}) {
    return useToast().success(msg, { position: "top-center", ...options });
  },
  error(msg, options = {}) {
    return useToast().error(msg, { position: "top-center", ...options });
  },
  warning(msg, options = {}) {
    return useToast().warning(msg, { position: "top-center", ...options });
  }
};

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      rememberMe: false,
      showPassword: false,
      isLoading: false,
      isOtpStep: false,
      otpCode: '',
      isOtpLoading: false,
      isResendingOtp: false,
      accountId: null,
      otpCountdown: 0,
      countdownTimer: null,
      errors: {
        username: '',
        password: '',
        otp: ''
      }
    };
  },
  computed: {
    formattedCountdown() {
      const minutes = Math.floor(this.otpCountdown / 60);
      const seconds = this.otpCountdown % 60;
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
  },
  mounted() {
    const registerSuccessMsg = localStorage.getItem('register-success-msg');
    if (registerSuccessMsg) {
      toast.success(registerSuccessMsg);
      localStorage.removeItem('register-success-msg');
    }
  },
  beforeUnmount() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    clearError(field) {
      this.errors[field] = '';
    },
    validateForm() {
      let isValid = true;

      if (!this.username) {
        this.errors.username = "Vui lòng nhập tên đăng nhập";
        isValid = false;
      }

      if (!this.password) {
        this.errors.password = "Vui lòng nhập mật khẩu";
        isValid = false;
      } else if (this.password.length < 6) {
        this.errors.password = "Mật khẩu phải có tối thiểu 6 ký tự";
        isValid = false;
      }

      return isValid;
    },

    onLoginSuccess(result, submittedUsername) {
      this.username = "";
      this.password = "";
      this.otpCode = "";
      this.isOtpStep = false;
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }

      const fullName = result.fullName || result.fullname || "";
      const username = result.username || submittedUsername;

      localStorage.setItem(
        "current-account",
        JSON.stringify({
          id: result.id,
          username: username,
          authority: result.authority,
          name: fullName,
          fullName: fullName
        })
      );

      const token = result.token;
      localStorage.setItem("token", token);
      if (result.refreshToken) {
        localStorage.setItem("refreshToken", result.refreshToken);
      }

      axios.defaults.headers['Authorization'] = `Bearer ${token}`;

      this.$router.push('/');
    },

    handleLogin() {
      if (!this.validateForm()) {
        return;
      }

      this.isLoading = true;

      const submittedUsername = this.username;

      // POST /account/v1/login-system
      axios
        .post("account/v1/login-system", {
          username: submittedUsername,
          password: this.password,
        })
        .then((response) => {
          const data = response.data;

          if (data.status === '500') {
            this.isLoading = false;
            toast.error(data.message || 'Đăng nhập thất bại.');
          } else if (data.status === '200') {
            this.isLoading = false;
            if (data.message === 'OTP_REQUIRED') {
              this.accountId = data.result;
              this.isOtpStep = true;
              this.startOtpCountdown();
              toast.info('Mã OTP đã được gửi đến email của bạn!');
            } else {
              this.onLoginSuccess(data.result, submittedUsername);
            }
          } else {
            this.isLoading = false;
            toast.error(data.message || 'Đăng nhập thất bại.');
          }
        })
        .catch((error) => {
          this.isLoading = false;
          toast.error("Có lỗi xảy ra, vui lòng kiểm tra lại kết nối hoặc liên hệ quản trị viên.");
          console.error("Login error:", error);
        });
    },

    startOtpCountdown() {
      this.otpCountdown = 180;
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.countdownTimer = setInterval(() => {
        if (this.otpCountdown > 0) {
          this.otpCountdown--;
        } else {
          clearInterval(this.countdownTimer);
        }
      }, 1000);
    },

    handleResendOtp() {
      if (this.isResendingOtp || !this.accountId) return;

      this.isResendingOtp = true;
      axios.post("account/v1/resend-otp", {
        accountId: this.accountId
      })
      .then(response => {
        this.isResendingOtp = false;
        if (response.data.status === '200') {
          toast.success("Mã OTP mới đã được gửi!");
          this.startOtpCountdown();
        } else {
          toast.error(response.data.message || "Lỗi gửi lại mã OTP");
        }
      })
      .catch(error => {
        this.isResendingOtp = false;
        toast.error(error.response?.data?.message || "Lỗi hệ thống khi gửi lại mã");
      });
    },

    handleVerifyOtp() {
      if (!this.otpCode || this.otpCode.length < 6) {
        this.errors.otp = 'Mã OTP không hợp lệ';
        return;
      }
      this.isOtpLoading = true;

      axios.post("account/v1/verify-login-otp", {
        accountId: this.accountId,
        otp: this.otpCode
      })
      .then((response) => {
        this.isOtpLoading = false;
        if (response.data.status === '200') {
          toast.success(response.data.message || 'Xác thực OTP thành công!');
          this.onLoginSuccess(response.data.result, this.username);
        } else {
          toast.error(response.data.message || 'Mã OTP không chính xác');
        }
      })
      .catch((error) => {
        this.isOtpLoading = false;
        toast.error("Có lỗi xảy ra trong quá trình xác thực OTP.");
        console.error("OTP verification error:", error);
      });
    }
  }
};

